export const LEGAL_TYPE_IDS = {
  individual: 'cb40e2a8-36ba-4e74-9b8b-d62ebed0e13d',
  organisation: '1e2c8225-c32c-4bf5-9718-1c4a029f3f06',
} as const;

export type TLegalType = keyof typeof LEGAL_TYPE_IDS;

export type TLegalTypeId = (typeof LEGAL_TYPE_IDS)[TLegalType];

const LEGAL_TYPE_BY_ID = Object.fromEntries(
  Object.entries(LEGAL_TYPE_IDS).map(([name, id]) => [id, name]),
) as Record<string, TLegalType>;

export const mapToLegalType = (uniqueId?: string): TLegalType | undefined =>
  uniqueId ? LEGAL_TYPE_BY_ID[uniqueId] : undefined;

export const getLegalTypeId = (type: TLegalType): TLegalTypeId => LEGAL_TYPE_IDS[type];
